import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { I18nService } from '@timechef/core/i18n/i18n.service';
import { LikesFilterEnum } from '@timechef/features/account/state/account.models';

@Component({
  selector: 'app-likes-filter-modal',
  templateUrl: './likes-filter-modal.component.html',
  styleUrls: ['./likes-filter-modal.component.scss'],
  standalone: false,
})
export class LikesFilterModalComponent implements OnInit {
  @Input() filter!: LikesFilterEnum;

  filterOptions = this.i18n.getOptions<LikesFilterEnum>('LikesFilterEnum', [LikesFilterEnum.All, LikesFilterEnum.OnlyNotifications]);

  filterCtrl = this.fb.control(LikesFilterEnum.All, [Validators.required]);

  constructor(
    private i18n: I18nService,
    private fb: FormBuilder,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit() {
    this.filterCtrl.setValue(this.filter);
  }

  async validate() {
    if (this.filterCtrl.invalid) return;

    await this.modalCtrl.dismiss(this.filterCtrl.value);
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
